import React from "react";

export class ImpressumDE extends React.Component {
    render() {
        return (
            <>
                <h3>Verantwortlich für die Website</h3>
                <p>DH Healthcare GmbH</p>

                <h3>Sitz und Registrierung</h3>
                <p>Bonn, Amtsgericht Bonn HRB 25633</p>

                <h3>Anschrift und Kontakt</h3>
                <p>
                    Konrad-Zuse-Platz 1-3
                    <br />
                    53227 Bonn, Deutschland
                </p>
                <p>
                    Telefon: +49 (0)228 / 2668 000
                    <br />
                    Fax: +49 (0) 228 / 2668 001
                    <br />
                    E-Mail: healthcare.de@dedalus.com
                </p>

                <h3>Gesetzliche Vertreter</h3>
                <p>
                    Herr Dieter Nels
                    <br />
                    Herr Daniel Strauch
                    <br />
                    Herr Winfried Post
                </p>
            </>
        );
    }
}
